import {gql} from "graphql-tag";

export const GET_USERS_DASHBOARD_QUERY = gql`
query GetUsersDashboard {
    getUsersDashboard {
        response {
            id
            status
            code
            message
        }
        data {
            totalUsers
            activeUsers
            inActiveUsers
            totalRoles
            userByRoles {
                roleName
                numberOfUsers
                percentageOfUsers
            }
        }
    }
}`
